/**
 * Tool name constants for the tool renderer system.
 * These match the tool names defined in the Go backend.
 */
export const TOOL_NAMES = {
  /** Place search tool (restaurants, hotels, attractions, POIs) */
  PLACE: 'place',
  /** Transportation search tool (flights, trains, buses) */
  TRANSPORTATION_SEARCH: 'transportation_search',
  /** Hotel search tool (hotels, resorts, lodging) */
  HOTEL_SEARCH: 'hotel_search',
  /** Imagery display tool (destination images) */
  IMAGERY_DISPLAY: 'imagery_display',
  /** Restaurant search tool */
  RESTAURANT_SEARCH: 'restaurant_search',
  /** Activity search tool (tours, experiences) */
  ACTIVITY_SEARCH: 'activity_search',
  /** Schedule constraint tool */
  SCHEDULE_CONSTRAINT: 'schedule_constraint',
  /** Preference update tool */
  PREFERENCE_UPDATE: 'preference_update',
} as const

/**
 * Type-safe tool name type derived from TOOL_NAMES
 */
export type ToolName = typeof TOOL_NAMES[keyof typeof TOOL_NAMES]

/**
 * Helper to check if a string is a known tool name
 */
export function isKnownToolName(name: string): name is ToolName {
  return Object.values(TOOL_NAMES).includes(name as ToolName)
}
